<div
  class="toast"
  [class.toast-type-error]="toastType() === ToastTypes.Error && theme() === GbTheme.ThemeTwo"
>
  <div class="toast-body">
    <div class="left-section flex-center">
      <div class="outer-circle flex-center">
        @switch (toastType()) {
          @case (ToastTypes.Success) {
            <svg
              class="inner-circle"
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              viewBox="0 0 20 20"
              fill="none"
            >
              <path
                d="M8.6 14.6L15.65 7.55L14.25 6.15L8.6 11.8L5.75 8.95L4.35 10.35L8.6 14.6ZM10 20C8.61667 20 7.31667 19.7373 6.1 19.212C4.88333 18.6873 3.825 17.975 2.925 17.075C2.025 16.175 1.31267 15.1167 0.788 13.9C0.262667 12.6833 0 11.3833 0 10C0 8.61667 0.262667 7.31667 0.788 6.1C1.31267 4.88333 2.025 3.825 2.925 2.925C3.825 2.025 4.88333 1.31233 6.1 0.787C7.31667 0.262333 8.61667 0 10 0C11.3833 0 12.6833 0.262333 13.9 0.787C15.1167 1.31233 16.175 2.025 17.075 2.925C17.975 3.825 18.6873 4.88333 19.212 6.1C19.7373 7.31667 20 8.61667 20 10C20 11.3833 19.7373 12.6833 19.212 13.9C18.6873 15.1167 17.975 16.175 17.075 17.075C16.175 17.975 15.1167 18.6873 13.9 19.212C12.6833 19.7373 11.3833 20 10 20Z"
                fill="currentColor"
              />
            </svg>
          }
          @case (ToastTypes.Error) {
            <svg
              class="inner-circle"
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="24"
              viewBox="0 0 24 24"
              fill="none"
            >
              <mask
                id="mask0_2_56685"
                style="mask-type: alpha"
                maskUnits="userSpaceOnUse"
                x="0"
                y="0"
                width="24"
                height="24"
              >
                <rect width="24" height="24" fill="#D9D9D9" />
              </mask>
              <g mask="url(#mask0_2_56685)">
                <path
                  d="M8.4 17L12 13.4L15.6 17L17 15.6L13.4 12L17 8.4L15.6 7L12 10.6L8.4 7L7 8.4L10.6 12L7 15.6L8.4 17ZM12 22C10.6167 22 9.31667 21.7375 8.1 21.2125C6.88333 20.6875 5.825 19.975 4.925 19.075C4.025 18.175 3.3125 17.1167 2.7875 15.9C2.2625 14.6833 2 13.3833 2 12C2 10.6167 2.2625 9.31667 2.7875 8.1C3.3125 6.88333 4.025 5.825 4.925 4.925C5.825 4.025 6.88333 3.3125 8.1 2.7875C9.31667 2.2625 10.6167 2 12 2C13.3833 2 14.6833 2.2625 15.9 2.7875C17.1167 3.3125 18.175 4.025 19.075 4.925C19.975 5.825 20.6875 6.88333 21.2125 8.1C21.7375 9.31667 22 10.6167 22 12C22 13.3833 21.7375 14.6833 21.2125 15.9C20.6875 17.1167 19.975 18.175 19.075 19.075C18.175 19.975 17.1167 20.6875 15.9 21.2125C14.6833 21.7375 13.3833 22 12 22Z"
                  fill="currentColor"
                />
              </g>
            </svg>
          }
        }
      </div>
    </div>
    <div class="right-section">
      <p class="primary-font-regular toast-message">
        <span [innerHTML]="message() | translate"></span>
        @if (specialContent()) {
          <span class="toaster-special-content" [innerHTML]="specialContent() || ''"></span>
        }
      </p>
    </div>
    @if (showDismiss()) {
      <button
        type="button"
        class="border-0 bg-transparent"
        data-bs-dismiss="toast"
        aria-label="Close"
      >
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="10"
          height="10"
          viewBox="0 0 10 10"
          fill="none"
        >
          <path
            d="M1.49101 0.245437L5 3.75428L8.49081 0.263617C8.56791 0.181548 8.6608 0.115896 8.7639 0.0705969C8.867 0.025298 8.97818 0.00128568 9.09079 0C9.33189 0 9.56311 0.095772 9.73359 0.266247C9.90408 0.436723 9.99985 0.667937 9.99985 0.909026C10.002 1.02047 9.98129 1.13118 9.93909 1.23435C9.89688 1.33752 9.83403 1.43097 9.75441 1.50898L6.21815 4.99964L9.75441 8.53575C9.90423 8.68232 9.99209 8.88081 9.99985 9.09026C9.99985 9.33134 9.90408 9.56256 9.73359 9.73303C9.56311 9.90351 9.33189 9.99928 9.09079 9.99928C8.97493 10.0041 8.85934 9.98475 8.75136 9.9425C8.64338 9.90025 8.54536 9.836 8.46354 9.75384L5 6.24501L1.5001 9.74475C1.42329 9.82409 1.33153 9.88742 1.23011 9.93111C1.1287 9.97479 1.01963 9.99796 0.909212 9.99928C0.668113 9.99928 0.436889 9.90351 0.266407 9.73303C0.095924 9.56256 0.000147911 9.33134 0.000147911 9.09026C-0.00197157 8.97881 0.0187068 8.8681 0.0609142 8.76493C0.103122 8.66176 0.165968 8.56831 0.245595 8.4903L3.78185 4.99964L0.245595 1.46353C0.0957678 1.31696 0.00791097 1.11848 0.000147911 0.909026C0.000147911 0.667937 0.095924 0.436723 0.266407 0.266247C0.436889 0.095772 0.668113 0 0.909212 0C1.12739 0.00272708 1.33647 0.0909025 1.49101 0.245437Z"
            fill="black"
          />
        </svg>
      </button>
    }
  </div>
</div>
